export enum OrganisationType {
  Developer,
  Standard,
  Verifier,
  Badge,
  DevelopmentManager,
  AssetManager,
}
